module.exports = __webpack_public_path__ + "img/32701006.5b122822.png";